<template>
    <div style="background-color:#E4E4E4 !important" class="neu-card plan-package mx-auto" :class="{ 'black': black }">
      <div>
        <div class="plan-package-pack">
          <h3 v-html="paddedTitle"></h3>
        </div>
        <div class="plan-package-price" :class="{ 'black': black }">
          <strong v-html="priceTitle"></strong>/{{ $t('cardsPricing.month') }}
        </div>
        <li style="color:#8A8A8A" v-html="text"></li>

      </div>
      <div class="plan-card-footer">
        <ul class="plan-card-footer-benefits">
          <li style="margin-top:2%" v-html="paddedSubtitle"></li>
        </ul>
        <ul class="plan-card-footer-benefits">
          <li style="margin-top:2%" v-html="paddedSubtitle1"></li>
        </ul>
        <ul class="plan-card-footer-benefits">
          <li v-if="paddedSubtitle2 != ''" style="margin-top:2%" v-html="paddedSubtitle2"></li>
        </ul>
        <ul class="plan-card-footer-benefits btn-card">
          <base-button class="btn-card-color" outline style="font-size:11px"  blue @click="goToRent()">{{ $t('rent') }}</base-button>
        </ul>
      </div>
    </div>
</template>

<script>
import opensaludprimeMixin from '@/mixins/opensaludprime.mixin'

const messages = {
  en: {
    cardsPricing: {
      month: 'month',
      'of-price': 'of price'
    }
  },
  es: {
    cardsPricing: {
      month: 'mes',
      'of-price': 'de precio'
    }
  }
}

export default {
  name: 'neu-card-pricing-prime',
  mixins: [opensaludprimeMixin],
  i18n: {
    messages
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
     subtitle1: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
     subtitle2: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    priceTitle: {
      type: String,
      required: true
    },
    subtitleLines: Number,
    titleLines: Number,
    black: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    goToRent () {
      if (this.id === 'single') {
        this.getOpensaludpassSingle()
      } else if (this.id === 'healthmind') {
        this.getWellness()
      } else {
        this.getOpensaludpass()
      }
    }
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines + 1)}` : this.title
    },
     paddedSubtitle () {
      return this.subtitleLines ? `${this.subtitle}${'<br>'.repeat(this.subtitleLines + 1)}` : this.subtitle
    },
    paddedSubtitle1 () {
      return this.subtitleLines ? `${this.subtitle1}${'<br>'.repeat(this.subtitleLines + 1)}` : this.subtitle1
    },
    paddedSubtitle2 () {
      return this.subtitleLines ? `${this.subtitle2}${'<br>'.repeat(this.subtitleLines + 1)}` : this.subtitle2
    }
  }
}
</script>

<style lang="scss">
 /*  @import "static/css/public/views/opensalud_profesionales.scss"; */

.neu-card-ctn {
  .neu-card {
    display: block;
    transition-duration: 1s;
    &:hover {
      @include desktop {
        padding: 4rem 6rem;
      }
      @include desktop-sm {
        padding: 2rem 4rem;
      }
      
      transition-duration: 1s;
    }
    
    /* box-shadow: $custom-shadow; */
    &:not(.black) {
      border: $border;
      border-radius: $border-radius;
    }
    // Neu Icon vertically centered
    span,div,h3 {
      display: flex;
      margin-block-end: 3rem;
    }
  }
}

.plan-package {
  display: initial;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 2.65em 2em 0;
}
@media screen and (min-width: 600px) {
  .plan-package {
    padding: 3.75em 3.75em 0;
  }
}
.plan-package-pack,
.plan-package-price {
  width: 100%;
  flex-shrink: 0;
}
@media screen and (min-width: 600px) {
  .plan-package-pack,
  .plan-package-price {
    width: 100%;
  }
}
.plan-package-pack {
  font-size: 1.1em;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  flex-direction: column;
  display:block;
}
.plan-package-pack h3 {
  font-size: inherit;
  font-weight: inherit;
  position: relative;
  text-align: center;
}
@media screen and (min-width: 600px) {
  .plan-package-pack {
    text-align: left;
  }
}
.plan-package-price {
  font-size: 1.2em;
  font-weight: 600;
  text-align: center;
  order: 1;

}
@media screen and (min-width: 600px) {
  .plan-package-price {
    justify-content: flex-end;
    order: inherit;
  }
}
.plan-package-price {
  &:not(.black) {
    color: #293356;
  }
  
  strong {
    font-size: 2.5rem;
    padding-right: 0.5rem;
  }
}

.plan-card-footer {
 .btn-card{
    @include desktop {
        position: absolute;
    bottom: 1rem;
    left: 0;
    }
     @include desktop-sm {
        position: absolute;
    bottom: 1rem;
    left: 0;
    }
     @include tablets {
        position: relative;
				button {
					margin-top: 1rem;
				}
    }
     @include mobile {
        position: relative;
    }

 }

  @include desktop {
    width:12rem;
    justify-content: center;
    align-items: center;  
    flex-direction: column;
    border-top: 2px solid rgb(204, 203, 203);  
  }

  @include media(tablets, mobile) {
    width:auto;
    justify-content: center;
    align-items: center;  
    flex-direction: column;
    border-top: 2px solid rgb(204, 203, 203);  
  }

}
@media screen and (min-width: 900px) {
  .plan-card-footer {
    margin-top: 10%;
    margin-right: 20%;

  }
}
@media screen and (min-width: 900px) {
  .plan-card-footer {
    margin-top: 10%;
    margin-right: 20%;
    position: initial;

  }
}
@media screen and (max-width: 900px) {
  .plan-package {
    margin-bottom: 40%;
    top: 20%;
    margin-right: 30%;
  }
}
.plan-card-footer-benefits,
.plan-card-footer-action {
  width: 100%;
}
.plan-card-footer-benefits {
  display: flex;
  flex-direction: column;
  align-items: center;
  .btn-card-color{
  background-color: transparent !important;
 border-color: $blue !important;
  }
  
}
@media screen and (min-width: 600px) {
  .plan-card-footer-benefits {
    display: initial;
  }
}
.plan-card-footer-benefits li {
  text-align:start;
  margin: 0;
  padding: 0.5em 0.5em;
  @include mobile {
    padding: 0.5em 0.5em;
  font-size: 9px;
  }
}
.plan-package li {
  text-align:start;
  margin: 0;
  padding: 0.5em 0.5em;
  @include desktop {
    padding: 0.5em 0.5em;
  font-size: 11px;
  }
  @include desktop-sm {
    padding: 0.5em 0.5em;
  font-size: 11px;
  }
  @include tablets {
    padding: 0.5em 0.5em;
  font-size: 11px;
  }
  @include mobile {
    padding: 0.5em 0.5em;
  font-size: 9px;
  }
}
.plan-card-footer-action {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.065em;
}

.black {
  color: $white !important;
}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardPricingPrime.vue